document.addEventListener('DOMContentLoaded', function() {
  var videoItems = document.querySelectorAll('.custom-video-item');

  videoItems.forEach(function(item) {
    var videoEl = item.querySelector('video');
    var playButton = item.querySelector('.play-button');
    var videoWrapper = item.querySelector('.custom-video-wrapper');

    var userInitiated = false;

    function showPlayButton() {
      playButton.style.display = 'block';
      playButton.removeAttribute('aria-hidden');
      playButton.setAttribute('aria-label', playButton.dataset.playLabel);
    }

    function hidePlayButton() {
      playButton.style.display = 'none';
      playButton.setAttribute('aria-hidden', 'true');
    }

    playButton.addEventListener('click', function(e) {
      e.stopPropagation();
      userInitiated = true;
      videoEl.play();
    });

    videoWrapper.addEventListener('click', function(e) {
      if (videoEl.controls) return;
      userInitiated = true;
      videoEl.paused ? videoEl.play() : videoEl.pause();
    });

    videoEl.addEventListener('play', function() {
      var allVideos = document.querySelectorAll('.custom-video-block video');
      allVideos.forEach(function(otherVideo) {
        if (otherVideo !== videoEl) {
          otherVideo.pause();
        }
      });

      videoEl.controls = true;
      videoEl.removeAttribute('aria-hidden');
      hidePlayButton();

      if (userInitiated) {
        videoEl.focus();
        userInitiated = false;
      }
    });

    videoEl.addEventListener('pause', function() {
      if (videoEl.ended) return;

      videoEl.controls = false;
      videoEl.setAttribute('aria-hidden', 'true');
      showPlayButton();
      playButton.focus();
    });

    videoEl.addEventListener('ended', function() {
      videoEl.controls = false;
      videoEl.setAttribute('aria-hidden', 'true');
      showPlayButton();
      playButton.focus();
    });
  });
});
